import React from 'react';
import Button from '../../Button.js';
const ModalBodyActions = ({
  primaryButton,
  secondaryButton,
  onPrimary,
  onSecondary
}) => {
  const hasButtons = primaryButton || secondaryButton;
  if (!hasButtons) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-modal__content__body__actions"
  }, primaryButton ? /*#__PURE__*/React.createElement(Button, {
    mode: Button.modes.PRIMARY,
    text: primaryButton,
    onClick: onPrimary
  }) : null, secondaryButton ? /*#__PURE__*/React.createElement(Button, {
    mode: Button.modes.SECONDARY,
    text: secondaryButton,
    onClick: onSecondary
  }) : null);
};
export default ModalBodyActions;